import { Component, Optional, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { MatterMortgagePriority, MatterMortgageType } from '@models/mortgage';
import { RadioGroupItem } from 'src/app/shared/atomic/atoms/radio-group/radio-group.component';
import { TestHooks } from './mortgage-priority-selector.hooks';

@Component({
	selector: 'app-mortgage-priority-selector',
	templateUrl: './mortgage-priority-selector.component.html',
	standalone: false,
})
export class MortgagePrioritySelectorComponent implements ControlValueAccessor {
	testHooks = TestHooks;
	public value: MatterMortgageType;
	public isDisabled: boolean;
	public onChange: (value: MatterMortgageType) => void;
	public onTouched: () => void;

	public priorityOptions: RadioGroupItem<MatterMortgagePriority>[] = [
		{ label: 'First', value: MatterMortgagePriority.PRIORITY_1 },
		{ label: 'Second', value: MatterMortgagePriority.PRIORITY_2 },
		{ label: 'Third', value: MatterMortgagePriority.PRIORITY_3 },
		{ label: 'Fourth', value: MatterMortgagePriority.PRIORITY_4 },
		{ label: 'Fifth', value: MatterMortgagePriority.PRIORITY_5 },
	];

	constructor(@Optional() @Self() public ngControl: NgControl) {
		if (this.ngControl != null) {
			// Setting the value accessor directly (instead of using the providers) to avoid running into a circular import.
			this.ngControl.valueAccessor = this;
		}
	}

	public writeValue(value: MatterMortgageType): void {
		this.value = value;
	}

	public registerOnChange(fn: (value: MatterMortgageType) => void): void {
		this.onChange = fn;
	}

	public registerOnTouched(fn: () => void): void {
		this.onTouched = fn;
	}

	public setDisabledState(isDisabled: boolean): void {
		this.isDisabled = isDisabled;
	}

	public selectValue(value: MatterMortgageType): void {
		this.value = value;
		this.onChange(value);
		this.onTouched();
	}
}
